import { Provider } from "../../../classes/provider/Provider";

const airtableProvider = new Provider({
	id: "airtable",
	name: "Airtable",
	description: "Airtable is a spreadsheet-database hybrid that lets you organize anything. It's flexible and easy to use, whether you're planning a vacation, sharing a household budget, or tracking inventory.",
	websiteHomeUrl: "https://airtable.com/",
	websiteSupportUrl: "https://support.airtable.com/hc/en-us",
	iconUrl: "https://storage.googleapis.com/cdn.version2.io/providers/airtable.png",
	color: "#66dbd7",
});

export default airtableProvider;
